module.exports = __webpack_public_path__ + "img/dawbg.e903544c.gif";